import { useLocation } from "react-router-dom";
import { User } from "lucide-react";
import { loadHelperSession } from "@/pages/FestivalHelperRedeem";
import { safeReplace } from "@/lib/safeNavigate";

export function PlayerModeSwitch() {
  const loc = useLocation();
  const s = loadHelperSession();
  if (!s?.player_return || loc.pathname === s.player_return || loc.pathname.includes("/me/")) return null;
  return (
    <button type="button" onClick={() => safeReplace(s.player_return)} data-testid="switch-player-mode"
      className="fixed bottom-4 left-4 z-[90] inline-flex items-center gap-2 px-4 py-2.5 text-[11px] uppercase tracking-widest font-bold bg-[#CCFF00] text-black border-2 border-black shadow-[0_0_16px_rgba(204,255,0,0.45)] hover:bg-white transition-colors">
      <User className="w-4 h-4" /> Switch to Player Mode
    </button>
  );
}

export default PlayerModeSwitch;
